import { APIRoute } from '@/modules/utils'
import { HydraCollection, IRI } from 'emt-library'
import { UserCard } from '@/dataV3/Search/UserCard'
import { SearchFiltersValues, SearchType } from '@/modules/Search/apiTypes/base'

export const AnimalRoute: APIRoute = {
  method: 'GET',
  path: '/animal/search',
}
export const MemberRoute: APIRoute = {
  method: 'GET',
  path: '/borrowers/search',
}
export const NextPageRoute = (nextPage: IRI): APIRoute => ({
  method: 'GET',
  path: nextPage,
})

export type SearchParams = {
  type: SearchType
  page?: number
  itemsPerPage?: number
  latitude?: number
  longitude?: number
} & SearchFiltersValues

export type Response = HydraCollection<UserCard>
